import { memo } from "react";
import { rgbToCss } from "utils/rgbToCss";
import { darkenRgb } from "components/SmartSurveyor/SmartSurveyorV3/utils/floorPlanLayout/darkenRgb";
import {
  LAYOUT_LABEL_BACKGROUND,
  LAYOUT_LABEL_CORNER_RADIUS_FACTOR,
  LAYOUT_LABEL_FONT_FAMILY,
  LAYOUT_LABEL_OUTLINE_OPACITY,
  LAYOUT_LABEL_OUTLINE_WIDTH,
} from "../constants";
import type { LayoutLabelProps } from "./types";

// A light badge with the text in a dark shade of the shape's colour, as the agent viewer draws it.
export const LayoutLabel = memo(function LayoutLabel({
  candidate,
  fontSize,
  fontWeight,
}: LayoutLabelProps) {
  const textColor = rgbToCss(darkenRgb({ rgb: candidate.rgb }));
  const badgeWidth = fontSize * candidate.badgeWidthPerFontSize;
  const badgeHeight = fontSize * candidate.badgeHeightPerFontSize;

  return (
    <g style={{ pointerEvents: "none" }}>
      <rect
        x={candidate.anchor.x - badgeWidth / 2}
        y={candidate.anchor.y - badgeHeight / 2}
        width={badgeWidth}
        height={badgeHeight}
        rx={fontSize * LAYOUT_LABEL_CORNER_RADIUS_FACTOR}
        fill={LAYOUT_LABEL_BACKGROUND}
        stroke={textColor}
        strokeOpacity={LAYOUT_LABEL_OUTLINE_OPACITY}
        strokeWidth={LAYOUT_LABEL_OUTLINE_WIDTH}
        vectorEffect="non-scaling-stroke"
      />
      <text
        x={candidate.anchor.x}
        y={candidate.anchor.y}
        fill={textColor}
        fontSize={fontSize}
        fontWeight={fontWeight}
        fontFamily={LAYOUT_LABEL_FONT_FAMILY}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {candidate.text}
      </text>
    </g>
  );
});
